import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData } from "../../serverRequest";
import LoadingSpinner from "../../components/Loadder";
//import moment from 'moment';
import AdminTicketListTable from "../Tables/AdminTicketListTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faDownload } from "@fortawesome/free-solid-svg-icons";
const XLSX = require('xlsx');

export default function AdminTicketList(props) {
  const companyID = props.companyId;
  const searchParams = new URLSearchParams(window.location.search);
  const ticketFilter = searchParams.get('filter');
  console.log(props);
  const [selectedCompanyId, setSelectedCompanyId] = React.useState(companyID);
  const [totalTickets, setTotalTickets] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  //const [data, setData] = useState([]);
  //const [totalPages, setTotalPages] = useState(0);
  //const [open, setOpen] = React.useState(true);
  //const [openTickets, setOpenTickets] = React.useState([]);

  /* const toggleDrawer = () => {
    setOpen(!open);
  };

  const formatDate = (dateString) => {
    return moment(dateString).format('DD/MM/YYYY');
  }; */

  const filterTicketData = (tickets_data) => {
    //console.log(tickets_data);
    let openTicket = [];
    let closeTicket = [];
    let totalTicket = [];
    if (tickets_data) {
      for (let i = 0; i < tickets_data.length; i++) {
        if (tickets_data[i]['status'] !== 'Resolved') {
          openTicket.push(tickets_data[i]);
          totalTicket.push(tickets_data[i]);
        }
        else if (tickets_data[i]['status'] === 'Resolved') {
          closeTicket.push(tickets_data[i]);
          totalTicket.push(tickets_data[i]);
        }
        else {
          totalTicket.push(tickets_data[i]);
        }
      }
    }

    if (ticketFilter == 'open') {
      totalTicket = openTicket;
    }
    else if (ticketFilter == 'closed') {
      totalTicket = closeTicket
    }

    //console.log(totalTicket);
    setTotalTickets(totalTicket);
    return ({ "open": openTicket, "close": closeTicket, "total": totalTicket })
  }
  
  React.useEffect(() => {

    async function fetchData() {
      await setSelectedCompanyId(selectedCompanyId);
      if (selectedCompanyId) {
        let resData = await getData('/api/tickets/?admin=1&company_id=' + selectedCompanyId)
        let tickets_data = resData['data']['tickets_data']
        //console.log(tickets_data);
        let ticketData = await filterTicketData(tickets_data)
      }
      else if (ticketFilter){
        let resData = await getData(`/api/tickets/?admin=1&?page=${page}&page_size=${pageSize}&ticket_filter=${ticketFilter}`)
        let tickets_data = resData['data']['tickets_data']
        
        //console.log(tickets_data);
        let ticketData = await filterTicketData(tickets_data)        
      }
      else {
        let resData = await getData('/api/tickets/?admin=1')
        let tickets_data = resData['data']['tickets_data']
        //console.log(tickets_data);
        let ticketData = await filterTicketData(tickets_data)
      }

      setLoading(false);
    }
    fetchData();


  }, [])

  return (
    <>
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (<>
        <div
          className={
            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
            ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
          }
        >

          <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4" key={selectedCompanyId?selectedCompanyId:0}>
            {/* Projects table */}
            <div className="flex justify-end mb-6">
              <button
                onClick={() => {
                  const ws = XLSX.utils.json_to_sheet(totalTickets);
                  const wb = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(wb, ws, "Tickets");
                  XLSX.writeFile(wb, "tickets.xlsx");
                }}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-3 ease-linear transition-all duration-150"
                title="Download"
              >
                <FontAwesomeIcon icon={faDownload} /> 
              </button>
            </div>
            <div style={{ width: '100%', padding: 0 }}>
              <AdminTicketListTable totalTickets={totalTickets}></AdminTicketListTable>
            </div>
          </div>
        </div>
      </>)}
    </>
  );
}

AdminTicketList.defaultProps = {
  color: "light",
};

AdminTicketList.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
